// JavaScript Document

 

var success_div = "#success_action";
var error_div = "#error_action";
var show_msg_delay = 5000;

 Shopify.moveAlong = function() {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          $('#add-item-to-cart').attr('disable',true).attr("value","Processing..");
          
          var request = Shopify.queue.shift();
          Shopify.addItem(request.variant_id, request.quantity, Shopify.moveAlong);
        }
        // If the queue is empty, we will redirect to the cart page.
        else {
          $(success_div).delay(100).html(' <span>Cart Updated!</span> <a href="/cart">View cart</a>').fadeIn(300).delay(show_msg_delay).fadeOut(300);  
     	  $('#add-item-to-cart').attr('disable',false).attr("value","Add to order");
        }  
      }; 


$(document).ready(function() {
  //m
  $('#add-item-to-cart').click(function() {
    
    Shopify.queue = [];
    var i = 0;
    $('.qty_tea').each(function() {
      
       idx = $(this).attr('data-idx');
       qty = $(this).val() * 1;
       if ( qty > 0  )
       { 
          Shopify.queue.push({ 
            variant_id: idx,
            quantity: qty
          });
         i++;
       }    
      
    });
    
    if ( i > 0 )
    Shopify.moveAlong();
    else
      alert("Please enter quantity!");
    
  });
  
  
  
}); /* end document ready */

function addtocart2(idx,qty) {   
    /*
     http://wiki.shopify.com/Ajax_API#Response_if_successful 
     http://wiki.shopify.com/Ajax_API#Response_if_error_2
    */ 
$.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data:  "quantity=" + qty + "&id=" + idx 
  });  
}


function addtocart(idx,qty) {   
    /*
     http://wiki.shopify.com/Ajax_API#Response_if_successful 
     http://wiki.shopify.com/Ajax_API#Response_if_error_2
    */ 
$.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data:  "quantity=" + qty + "&id=" + idx,
    success: addsucessinfo,
    error: errorinfo
  });  
}

function changecart(idx,qty)
{
    $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data:  "quantity=" + qty + "&id=" + idx 
  });   
}
function addtocart_checkout(idx,qty) {   
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data:  "quantity=" + qty + "&id=" + idx,
    success: gotocheckout,
    error: errorinfo
  });  
}

function addsucessinfo(response)
{ 
     $(success_div).html(response.title + ' <span>has been added to your cart!</span> <a href="/cart">View cart</a>').fadeIn(300).delay(show_msg_delay).fadeOut(300);  
     getcart();
	 }

function errorinfo(obj, status)
{
     try {
        var response = jQuery.parseJSON(obj.responseText);
        $(error_div).html(response.description).fadeIn(300).delay(show_msg_delay).fadeOut(300);
      } catch(e) {
        $(error_div).html("There was an error").fadeIn(300).delay(show_msg_delay).fadeOut(300);
      }
}
function gotocheckout()
{
    document.location = '/cart'  ; 
}

function getcart()
{
    $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: cartitemcount,
    error: errorinfo
  });   
  
    cartitemcount();
}
function getcart2(response)
{
    $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: cartitemcount,
    error: errorinfo
  });   
}
function cartitemcount (response)
{ 
     $('.item-count').html(response.item_count);  
}